//Quick View

jQuery(document).ready(function (jQuery) {
  jQuery.getScript("//cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js").done(function() {
    quickView();
  });
});

function quickView() {
  jQuery(document).on('click','.quick-view',function(){
    jQuery('.quick-view.active').removeClass('active');
    jQuery(this).addClass('active');
    var json_p =  JSON.parse(jQuery(this).attr('data-json')); 
    if (jQuery('#quick-view').length == 0){jQuery("body").append('<div id="quick-view"></div>');}
    var product_handle = jQuery(this).data('handle');
    jQuery('#quick-view').addClass(product_handle);
    var whislist_html = jQuery(this).closest('li.grid__item').find('.custom_wishid_sec').html();
    
    jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
      var title = product.title;
      var type = product.type;
      var price = 0;
      var original_price = 0;
      var desc = product.description;
      var images = product.images;
      var variants = product.variants;
      var options = product.options; 
      var url = '/products/' + product_handle;
      jQuery('.qv-product-title').text(title);
      jQuery('.quick_view_title_section .whislist_icon').html(whislist_html);
      //jQuery('.qv-product-description').html(desc);     
      jQuery('.view-product').attr('href', url);
      var imageCount = jQuery(images).length;
      jQuery(images).each(function (i, image) {
        if (i == imageCount - 1) {
          var image_embed = '<div><img src="' + image + '"></div>';
          image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
          jQuery('.qv-product-images').append(image_embed);

          jQuery('.qv-product-images').slick({
            'dots': false,
            'arrows': true,
            'respondTo': 'min',
            'useTransform': false
          }).css('opacity', '1');

        } else {
          image_embed = '<div><img src="' + image + '"></div>';
          image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
          jQuery('.qv-product-images').append(image_embed);
        }
      });
      jQuery(options).each(function (i, option) {
        var opt = option.name;
        var selectClass = '.option.' + opt.toLowerCase();
        jQuery('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + '"><span class="option">' + opt + '</span><select class="option-' + i + ' option ' + opt.toLowerCase() + '"></select></div>');
        jQuery(option.values).each(function (i, value) {
          jQuery('.option.' + opt.toLowerCase()).append('<option value="' + value + '">' + value + '</option>');
        });
      });
      jQuery(product.variants).each(function (i, v) {
        var quan = 0;
        for (var p = 0; p < json_p.length; p++){
          if(json_p[p].id == v.id){
            quan = json_p[p].stock;
          }
        }
        if (quan < 1 && v.inventory_management == 'shopify' && v.available != true) {
          jQuery('.qv-add-button').prop('disabled', true).val('Sold Out');
          price = parseFloat(v.price / 100).toFixed(2);
          original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
          if (original_price > 0) {
            jQuery('.qv-product-price').html('<span>$' + price+'</span>');
            jQuery('.qv-product-original-price').html('<span>$' + original_price+'</span>').show();
          } else {
             jQuery('.qv-product-price').html('$' + price);
             jQuery('.qv-product-original-price').hide();
          }
          jQuery('select.option-0').val(v.option1);
          jQuery('select.option-1').val(v.option2);
          jQuery('select.option-2').val(v.option3);
          jQuery('.preorder_discout_bar').hide();
          return false
        }else if (quan < 1 && v.inventory_management == 'shopify' && v.available == true) {
          jQuery('.qv-add-button').prop('disabled', false).val('Pre Order');
          price = parseFloat(v.price / 100).toFixed(2);
          original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
          if (original_price > 0) {
            jQuery('.qv-product-price').html('<span>$' + price+'</span>');
            jQuery('.qv-product-original-price').html('<span>$' + original_price+'</span>').show();
            if(original_price > price){
              var discount = (parseFloat(original_price) - parseFloat(price)).toFixed(2);
              var discount_bar = '<p class="pre_order_discount_text">Pre-Order now available! Wait &amp; Save extra $'+discount+'</p>';
              jQuery('.preorder_discout_bar').html(discount_bar);
              jQuery('.preorder_discout_bar').show();
            }
          }else {
            jQuery('.qv-product-price').html('$' + price);
            jQuery('.qv-product-original-price').hide();
          }
          jQuery('select.option-0').val(v.option1);
          jQuery('select.option-1').val(v.option2);
          jQuery('select.option-2').val(v.option3);
          return false
        }else if(v.available == true) { 
          price = parseFloat(v.price / 100).toFixed(2);
          original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
          if (original_price > 0) {
            jQuery('.qv-product-price').html('<span>$' + price+'</span>');
            jQuery('.qv-product-original-price').html('<span>$' + original_price+'</span>').show();
          } else {
             jQuery('.qv-product-price').html('$' + price);
            jQuery('.qv-product-original-price').hide();
          }
          jQuery('select.option-0').val(v.option1);
          jQuery('select.option-1').val(v.option2);
          jQuery('select.option-2').val(v.option3);
          jQuery('.preorder_discout_bar').hide();
          return false
        }else{
          jQuery('.qv-add-button').prop('disabled', true).val('Sold Out');
          price = parseFloat(v.price / 100).toFixed(2);
          original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
          if (original_price > 0) {
            jQuery('.qv-product-price').html('<span>$' + price+'</span>');
            jQuery('.qv-product-original-price').html('<span>$' + original_price+'</span>').show();
          } else {
             jQuery('.qv-product-price').html('$' + price);
            jQuery('.qv-product-original-price').hide();
          }
          jQuery('select.option-0').val(v.option1);
          jQuery('select.option-1').val(v.option2);
          jQuery('select.option-2').val(v.option3);
          jQuery('.preorder_discout_bar').hide();
          return false
        }
      });
    });

    jQuery(document).on("change", "#quick-view select", function () {
      var selectedOptions = '';
      jQuery('#quick-view select').each(function (i) {
        if (selectedOptions == '') {
          selectedOptions = jQuery(this).val();
        } else {
          selectedOptions = selectedOptions + ' / ' + jQuery(this).val();
        }
      });
      var json_p =  JSON.parse(jQuery('.quick-view.active').attr('data-json')); 
      var product_handle = jQuery('.quick-view.active').data('handle');
      jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
        jQuery(product.variants).each(function (i, v) {
          if (v.title == selectedOptions) {
            console.log(v);
            var quan = 0;
            for (var p = 0; p < json_p.length; p++){
              if(json_p[p].id == v.id){
                quan = json_p[p].stock;
              }
            }
            
            var price = parseFloat(v.price / 100).toFixed(2);
            var original_price = parseFloat(v.compare_at_price / 100).toFixed(2);            
            var v_inv = v.inventory_management;           
            if (original_price > 0) {
              jQuery('.qv-product-price').html('<span>$' + price+'</span>');
              jQuery('.qv-product-original-price').html('<span>$' + original_price+'</span>').show();
            } else {
               jQuery('.qv-product-price').html('$' + price);
              jQuery('.qv-product-original-price').hide();
            }            
            if (v_inv == null) {
              jQuery('.qv-add-button').prop('disabled', false).val('Add to Cart');
              jQuery('.preorder_discout_bar').hide();
            }else if (quan < 1 && v.inventory_management == 'shopify' && v.available != true) {
                jQuery('.qv-add-button').prop('disabled', true).val('Sold Out');
                jQuery('.preorder_discout_bar').hide();
            }else if (quan < 1 && v.inventory_management == 'shopify' && v.available == true) {
                 jQuery('.qv-add-button').prop('disabled', false).val('Pre Order');
                  if(original_price > price){
                  var discount = (parseFloat(original_price) - parseFloat(price)).toFixed(2);
                  var discount_bar = '<p class="pre_order_discount_text">Pre-Order now available! Wait &amp; Save extra $'+discount+'</p>';
                  jQuery('.preorder_discout_bar').html(discount_bar);
                  jQuery('.preorder_discout_bar').show();
                }
            } else if(v.available == true) { 
                jQuery('.qv-add-button').prop('disabled', false).val('Add to Cart');
            }else{
               jQuery('.qv-add-button').prop('disabled', true).val('Sold Out');
            }            
          }
        });
      });
    });
    jQuery.fancybox({
      href: '#quick-view',
      maxWidth: 1040,
      maxHeight: 600,
      fitToView: true,
      width: '75%',
      height: '70%',
      autoSize: false,
      closeClick: false,
      openEffect: 'none',
      closeEffect: 'none',
      'beforeLoad': function () {
        var product_handle = jQuery('#quick-view').attr('class');
        jQuery(document).on("click", ".qv-add-button", function () {
          var qty = jQuery('.qv-quantity').val();
          var selectedOptions = '';
          var var_id = '';
          jQuery('#quick-view').closest('.fancybox-skin').append('<div class="quickview-loading"><span>Adding to cart...</span></div>');
          jQuery('.quickview-loading').show();
          jQuery('#quick-view select').each(function (i) {
            if (selectedOptions == '') {
              selectedOptions = jQuery(this).val();
            } else {
              selectedOptions = selectedOptions + ' / ' + jQuery(this).val();
            }
          });          
          jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
            jQuery(product.variants).each(function (i, v) {
              if (v.title == selectedOptions) {
                var_id = v.id;
                processCart();
              }
            });
          });
          function processCart() {
            jQuery.post('/cart/add.js', {
              quantity: qty,
              id: var_id
            },
                        null,
                        "json"
                       ).done(function () {
              fetchCart();
              jQuery('.qv-add-to-cart-response').addClass('success').html('<span>' + jQuery('.qv-product-title').text() + ' has been added to your cart. <a href="/cart">Click here to view your cart.</a>');
              jQuery('.quickview-loading').addClass('added');
              setTimeout(function(){
                 jQuery('.qv-add-to-cart-response').removeClass('success');
                 jQuery('.quickview-loading').remove();
              },4000);
            })
            .fail(function (jQueryxhr) {
              var data = jQueryxhr.responseJSON;
              jQuery('.qv-add-to-cart-response').addClass('error').html('<span><b>ERROR: </b>' + data.description);
              jQuery('.quickview-loading').addClass('error');
              jQuery('.quickview-loading span').html('Sorry, something went wrong. Please try again');
              setTimeout(function(){
                 jQuery('.qv-add-to-cart-response').removeClass('error');
                 jQuery('.quickview-loading').remove();
              },4000);
            });
          }
        });
        jQuery('.fancybox-wrap').css('overflow', 'hidden !important');
      },
      'afterShow': function () {
        jQuery('#quick-view').hide().html(content).css('opacity', '1').fadeIn(function () {
          jQuery('.qv-product-images').addClass('loaded');
        });
      },
      'afterClose': function () {
        jQuery('#quick-view').removeClass().empty();
        jQuery('.quick-view.active').removeClass('active');
      }
    });

    jQuery('.quick_view_quantity button').on('click',function(e){
        e.preventDefault();
        var val = jQuery('.quick_view_quantity input').val();
        if(val == null || val == 'undefiend'){
          val = 0;
        }
        if(val > 1 && jQuery(this).hasClass('quick-qty-minus')){
           val = parseInt(val) - parseInt(1);
        }else if(jQuery(this).hasClass('qty-plus')){
          val = parseInt(val) + parseInt(1);
        }
        jQuery('.quick_view_quantity input').val(val);
    });

    
  });
};

jQuery(window).resize(function () {
  if (jQuery('#quick-view').is(':visible')) {
    jQuery('.qv-product-images').slick('setPosition');
  }
});